import { render, staticRenderFns } from "./SvgTelegram.vue?vue&type=template&id=d5a661b2"
import script from "./SvgTelegram.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgTelegram.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports